var React = require('react');

function Selected (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","stroke":"#0088BF","key":0}),React.createElement("circle",{"cx":"8","cy":"8","r":"5","fill":"#0088BF","key":1})]));
}

Selected.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Selected;

Selected.default = Selected;
